import { useEventContext } from '../../../app/provider/useEventContext';

export const usePlatformData = () => {
    return useEventContext();
};
